import { render, staticRenderFns } from "./CargoCrudStatusWaitingUnload.vue?vue&type=template&id=235720c4"
import script from "./CargoCrudStatusWaitingUnload.vue?vue&type=script&lang=js"
export * from "./CargoCrudStatusWaitingUnload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports